var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.844,
    y: 1.504,
    width: 24.168,
    height: 24.275,
    rx: 12.084,
    fill: "#fff",
    stroke: "#FF6040",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speaker_svg__clip0_1748_939)",
    fill: "#FF6040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.86 10.65H8.626v5.983h3.236l2.474 2.991h.761V7.66h-.761l-2.474 2.99zM17.951 13.642c0-.6-.216-1.178-.604-1.62a2.25 2.25 0 00-1.49-.764v1.205c.267.047.508.19.682.407.174.216.27.49.27.772 0 .283-.096.556-.27.772-.174.216-.416.36-.682.408v1.205a2.25 2.25 0 001.49-.766 2.46 2.46 0 00.604-1.619z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.857 8.519v1.215c1.736.37 3.046 1.982 3.046 3.908s-1.31 3.538-3.046 3.908v1.215c2.369-.384 4.188-2.535 4.188-5.123s-1.82-4.738-4.188-5.123z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "speaker_svg__clip0_1748_939"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.244 7.26)",
    d: "M0 0h12.181v12.762H0z"
  })))));
}
export default __webpack_public_path__ + "59cc59192a1cede7c02413983f07cfcb.svg";
export { SvgSpeaker as ReactComponent };